import { render, staticRenderFns } from "./LatestComponent.vue?vue&type=template&id=56593142&scoped=true"
import script from "./LatestComponent.vue?vue&type=script&lang=js"
export * from "./LatestComponent.vue?vue&type=script&lang=js"
import style0 from "./LatestComponent.vue?vue&type=style&index=0&id=56593142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56593142",
  null
  
)

export default component.exports